import React from "react";
import styled from "./MessageForm.module.css";

const MessageForm = React.forwardRef(function (props, ref) {
  return (
    <React.Fragment>
      <form onSubmit={props.onSubmit} className={styled.form}>
        <label htmlFor={"form"}>
          <h1>Your Name:</h1>
        </label>
        <input type="text" id="form" ref={ref} />
        <div>
          <button className={styled.submit}>Submit</button>
        </div>
      </form>
    </React.Fragment>
  );
});

export default MessageForm;
